export default "__VITE_ASSET__8$s61jkM__"